<template>
  <section class="user__profile visited">
    <Loading
      v-if="isLoading"
      shape="circle"
      :stroke-width="8"
      :size="96"
      rotate
      :indeterminate="true"
    />
    <template v-else>
      <InfoBox
        v-if="!visitedUser.createdAt"
        :content="$t('placeholders.NO_VISITED_USER')"
      />
      <template v-else>
        <UserProfileCard
          :id="'visited_profile'"
          :user="userProfile"
          :is-current-user="false"
          :alias="isAlias"
          :heading="$t('headings.PROFILE_VISITED')"
        />
        <list
          id="visited_comments"
          :heading="$t('headings.COMMENTS_RECENT_VISITED')"
          :items="visitedComments"
          :placeholders="placeholders"
          :empty="'placeholders.NO_COMMENTS'"
        >
          <template v-slot:item="{ item }">
            <comment
              :key="item.id"
              :comment="item"
              :user="visitedUser"
            />
          </template>
        </list>
      </template>
    </template>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Comment from "../components/global/Comment";
import List from "../components/global/List";
import Loading from "../components/global/Loading";
import SkeletonPost from "../components/global/SkeletonPost";
import UserProfileCard from "../components/user-profile/UserProfileCard";
import InfoBox from "../components/global/InfoBox.vue";

export default {
  name: "VisitedProfile",
  components: {
    Comment,
    List,
    Loading,
    UserProfileCard,
    InfoBox,
  },
  data() {
    return {
      isAlias: false,
    };
  },
  created() {
    this.getVisitedProfile();
  },
  methods: {
    ...mapActions(["getVisitedProfile"]),
  },
  computed: {
    ...mapGetters(["isLoading", "visitedComments", "visitedUser"]),
    placeholders() {
      return {
        count: 3,
        component: SkeletonPost,
      };
    },
    userExists() {
      if (this.visitedUser?.createdAt) return true;
      return false;
    },
    userProfile() {
      return {
        firstName: this.visitedUser.firstName,
        lastName: this.visitedUser.lastName,
        name: this.visitedUser.name,
        alias: this.isAlias,
        picture: this.visitedUser.profilePicture,
        rotation: this.visitedUser.imageRotation,
        description: this.visitedUser.description,
        date: this.visitedUser.createdAt,
        comments: this.visitedUser.numComments,
        slug: this.visitedUser.slug,
      };
    },
  },
  watch: {
    visitedUser() {
      if (this.visitedUser.name) this.isAlias = true;
    },
  },
};
</script>
